import ProjectCard from "../components/ProjectCard";
import { projects } from "../data/projects";

export default function Projects() {
  return (
    <section id="projects" className="min-vh-100 deeper py-5">
      <div className="pt-5 pb-3 px-md-3 mx-3 mx-lg-5 mt-3 mb-5">
        <h2 className="fw-bold fs-1">PROJECTS</h2>
        <div className="container py-3 mx-0">
          <div className="row gap-4">
            {projects.map((project, index) => (
              <ProjectCard key={index} project={project} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
